(function () {
  "use strict";

  /*
   * ============================================================
   * DRIP STREET — PDP IMAGE VIEWER
   * ============================================================
   *
   * PDP:
   * - toque/clique na imagem abre fullscreen
   * - swipe normal da galeria continua funcionando
   *
   * FULLSCREEN:
   * - pinch zoom
   * - duplo toque / duplo clique = zoom
   * - arrastar imagem quando ampliada
   * - swipe troca imagem quando zoom = 100%
   * - + / - controlam zoom
   * - roda do mouse controla zoom no desktop
   * - setas esquerda/direita no teclado
   * - ESC fecha
   */

  var GLOBAL_KEY = "dsPdpFullscreenViewerV3";
  var STYLE_ID = "DsPdpFullscreenViewerStylesV3";
  var VIEWER_ID = "DsPdpFullscreenViewerV3";

  var MIN_SCALE = 1;
  var MAX_SCALE = 4;
  var DOUBLE_SCALE = 2.35;

  var SWIPE_THRESHOLD = 55;
  var GALLERY_MOVE_CANCEL = 10;
  var DOUBLE_TAP_TIME = 290;
  var DOUBLE_TAP_DISTANCE = 45;

  /*
   * ============================================================
   * DESATIVA CONTROLADORES ANTIGOS
   * ============================================================
   */

  window.dsPdpImmediateHoldZoomV1 = true;
  window.dsPdpMobileZoomControllerV4 = true;
  window.dsPdpMobileZoomControllerV5 = true;
  window.dsPdpMobileZoomControllerV6 = true;

  if (
    window[GLOBAL_KEY] &&
    typeof window[GLOBAL_KEY].destroy === "function"
  ) {
    window[GLOBAL_KEY].destroy();
  }

  /*
   * ============================================================
   * VARIÁVEIS
   * ============================================================
   */

  var viewer = null;
  var stage = null;
  var viewerImage = null;

  var closeButton = null;
  var prevButton = null;
  var nextButton = null;

  var minusButton = null;
  var plusButton = null;
  var zoomLabel = null;

  var counter = null;
  var hint = null;

  var items = [];
  var currentIndex = 0;

  var opened = false;
  var originalImage = null;

  var scale = 1;
  var panX = 0;
  var panY = 0;

  var pointers = new Map();

  var dragStartX = 0;
  var dragStartY = 0;

  var dragStartPanX = 0;
  var dragStartPanY = 0;

var pinchStartDistance = 0;
var pinchStartScale = 1;

/*
 * Ponto real da imagem que estava
 * entre os dois dedos no início da pinça.
 */
var pinchFocalX = 0;
var pinchFocalY = 0;


/*
 * ============================================================
 * HOLD ZOOM — ZOOM RÁPIDO DIRETO NA PDP
 * ============================================================
 */

var HOLD_SCALE = 1.95;
var HOLD_DELAY = 520;
var HOLD_MOVE_CANCEL = 5;

var holdTimer = 0;

var holdTouching = false;
var holdActive = false;
var holdMoved = false;

var holdImage = null;
var holdTarget = null;

var holdStartX = 0;
var holdStartY = 0;

var holdPanX = 0;
var holdPanY = 0;

var holdMaxPanX = 0;
var holdMaxPanY = 0;

  var lastTapTime = 0;
  var lastTapX = 0;
  var lastTapY = 0;

  /*
   * Controle para impedir que um SWIPE
   * na galeria original abra o fullscreen.
   */

  var galleryPointer = null;
  var galleryStartX = 0;
  var galleryStartY = 0;
  var galleryMoved = false;

  // Gestos de rolagem podem terminar em pointercancel sem pointermove.
  // Guardamos também touchmove, scroll e a posição inicial do carrossel.
  var galleryStartAt = 0;
  var galleryLastPointerType = "";
  var galleryStartPageY = 0;
  var galleryStartPageX = 0;
  var galleryStartTrackX = 0;
  var galleryTouchTrack = null;
  var GALLERY_TAP_MAX_MS = 550;

  var suppressGalleryClickUntil = 0;
var galleryTouchPointers = new Set();
var galleryMultiTouch = false;
  /*
   * Scroll da página antes de abrir modal.
   */

  var pageScrollY = 0;
  var bodyBackup = null;

  /*
   * ============================================================
   * HELPERS
   * ============================================================
   */

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function getPdpRoot(element) {
    var node = element;

    while (node && node !== document.documentElement) {
      if (
        node.tagName &&
        node.tagName.toLowerCase().indexOf("sneaker-pdp-") === 0
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return null;
  }

  /*
   * Só permite abrir zoom:
   *
   * MOBILE:
   * imagem dentro dos slides
   *
   * DESKTOP:
   * imagem principal
   */

  function getProductImage(target) {
    if (!target) return null;

    var image =
      target.tagName &&
      target.tagName.toLowerCase() === "img"
        ? target
        : target.closest
          ? target.closest("img")
          : null;

    if (!image) return null;

    if (
      image.closest(
        '[class*="ai-sneaker-pdp-mobile-gallery-"]'
      ) &&
      image.closest("[data-mobile-slide]")
    ) {
      return image;
    }

    if (
      image.closest(
        '[class*="ai-sneaker-pdp-main-image-"]'
      )
    ) {
      return image;
    }

    return null;
  }

  /*
   * Tenta buscar uma imagem Shopify
   * maior que a usada visualmente na PDP.
   */

  function highResolution(url) {
    if (!url) return "";

    try {
      var parsed = new URL(
        url,
        window.location.href
      );

      if (
        parsed.pathname.indexOf("/cdn/shop/") !== -1 ||
        parsed.hostname.indexOf("cdn.shopify.com") !== -1
      ) {
        parsed.searchParams.set(
          "width",
          "2400"
        );
      }

      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function imageKey(url) {
    if (!url) return "";

    try {
      var parsed = new URL(
        url,
        window.location.href
      );

      return (
        parsed.origin +
        parsed.pathname
      );
    } catch (error) {
      return String(url).split("?")[0];
    }
  }

  function currentImageSource(image) {
    if (!image) return "";

    return highResolution(
      image.currentSrc ||
      image.getAttribute("src") ||
      image.src ||
      ""
    );
  }

  /*
   * ============================================================
   * COLETA TODAS AS FOTOS DO PRODUTO
   * ============================================================
   */

  function collectImages(root) {
    var result = [];
    var seen = {};

    function push(src, alt) {
      if (!src) return;

      var high = highResolution(src);
      var key = imageKey(high);

      if (!high || seen[key]) return;

      seen[key] = true;

      result.push({
        src: high,
        alt: alt || "Imagem do produto"
      });
    }

    if (!root) return result;

    /*
     * Prioridade:
     * slides mobile.
     *
     * Eles possuem todas as imagens do produto.
     */

    root
      .querySelectorAll(
        "[data-mobile-slide] img"
      )
      .forEach(function (img) {
        push(
          img.currentSrc ||
            img.getAttribute("src") ||
            img.src,

          img.getAttribute("alt")
        );
      });

    /*
     * Fallback desktop.
     */

    if (!result.length) {
      root
        .querySelectorAll(
          "[data-ai-thumb]"
        )
        .forEach(function (thumb) {
          var thumbImg =
            thumb.querySelector("img");

          push(
            thumb.getAttribute(
              "data-image"
            ) ||
              (
                thumbImg &&
                (
                  thumbImg.currentSrc ||
                  thumbImg.src
                )
              ),

            thumbImg
              ? thumbImg.getAttribute("alt")
              : ""
          );
        });
    }

    /*
     * Último fallback:
     * imagem principal.
     */

    if (!result.length) {
      var main =
        root.querySelector(
          '[id^="AiSneakerMainImage-"]'
        );

      if (main) {
        push(
          main.currentSrc ||
            main.src,

          main.getAttribute("alt")
        );
      }
    }

    return result;
  }

  /*
   * Descobre qual foto foi clicada.
   */

  function findInitialIndex(
    root,
    clickedImage
  ) {
    if (!items.length) return 0;

    /*
     * MOBILE
     */

    if (clickedImage) {
      var clickedKey =
        imageKey(
          currentImageSource(
            clickedImage
          )
        );

      var match =
        items.findIndex(
          function (item) {
            return (
              imageKey(item.src) ===
              clickedKey
            );
          }
        );

      if (match >= 0) {
        return match;
      }
    }

    /*
     * DESKTOP:
     * usa thumbnail ativa.
     */

    if (root) {
      var activeThumb =
        root.querySelector(
          "[data-ai-thumb].is-active"
        );

      if (activeThumb) {
        var src =
          activeThumb.getAttribute(
            "data-image"
          );

        var activeKey =
          imageKey(
            highResolution(src)
          );

        var activeMatch =
          items.findIndex(
            function (item) {
              return (
                imageKey(item.src) ===
                activeKey
              );
            }
          );

        if (activeMatch >= 0) {
          return activeMatch;
        }
      }
    }

    return 0;
  }

  /*
   * ============================================================
   * REMOVE RESÍDUOS DO ZOOM ANTIGO
   * ============================================================
   */

  function cleanupOldZoom() {
    [
      "DsPdpImmediateHoldZoomStylesV1",
      "DsPdpMobileZoomStylesV4",
      "DsPdpMobileZoomStylesV5",
      "DsPdpMobileZoomStylesV6"
    ].forEach(function (id) {
      var style =
        document.getElementById(id);

      if (style) {
        style.remove();
      }
    });

    document
      .querySelectorAll(
        ".ds-pdp-zoom-surface," +
        ".ds-pdp-zoom-modal," +
        ".ds-hold-zoom-lens"
      )
      .forEach(function (element) {
        element.remove();
      });

    document
      .querySelectorAll(
        ".ds-pdp-immediate-zoom-target," +
        ".ds-pdp-zoom-target," +
        ".ds-pdp-zoom-preview," +
        ".ds-pdp-zoomed," +
        ".ds-pdp-zoom-target-v6"
      )
      .forEach(function (element) {
        element.classList.remove(
          "ds-pdp-immediate-zoom-target",
          "is-active",
          "ds-pdp-zoom-target",
          "ds-pdp-zoom-preview",
          "ds-pdp-zoom-preview-release",
          "ds-pdp-zoomed",
          "ds-pdp-zoom-target-v6",
          "is-previewing",
          "is-full-zoom",
          "is-hold-zooming"
        );
      });

    document.documentElement.classList.remove(
      "ds-pdp-immediate-zooming",
      "ds-pdp-zoom-open",
      "ds-hold-img-zooming",
      "ds-pdp-zoom-active-v6"
    );

    document.body.classList.remove(
      "ds-pdp-immediate-zooming",
      "ds-pdp-zoom-open",
      "ds-hold-img-zooming",
      "ds-pdp-zoom-active-v6"
    );
  }

  /*
   * ============================================================
   * CSS
   * ============================================================
   */

  function injectStyles() {
    var existing =
      document.getElementById(
        STYLE_ID
      );

    if (existing) {
      existing.remove();
    }

    var style =
      document.createElement(
        "style"
      );

    style.id = STYLE_ID;

    style.textContent = `

      /*
       * Imagem clicável.
       */

      [class*="ai-sneaker-pdp-mobile-gallery-"] img,
      [class*="ai-sneaker-pdp-main-image-"] img {
        cursor: zoom-in;
      }


      /*
       * MODAL
       */

      #${VIEWER_ID} {
        position: fixed;
        inset: 0;

        width: 100vw;
        height: 100dvh;

        z-index: 2147483000;

        display: flex;
        align-items: center;
        justify-content: center;

        background: #ffffff;

        opacity: 0;
        visibility: hidden;
        pointer-events: none;

        transition:
          opacity 180ms ease,
          visibility 180ms ease;

        font-family:
          Inter,
          Arial,
          sans-serif;

        overscroll-behavior: none;
      }


      #${VIEWER_ID}.is-open {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
      }


      /*
       * STAGE
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-stage {
        position: absolute;
        inset: 0;

        width: 100%;
        height: 100%;

        display: flex;
        align-items: center;
        justify-content: center;

        overflow: hidden;

        touch-action: none;
        user-select: none;
        -webkit-user-select: none;

        cursor: zoom-in;
      }


      #${VIEWER_ID}.is-zoomed
      .ds-pdp-viewer-stage {
        cursor: grab;
      }


      #${VIEWER_ID}.is-dragging
      .ds-pdp-viewer-stage {
        cursor: grabbing;
      }


      /*
       * IMAGEM
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-image {
        display: block;

        width: auto;
        height: auto;

        max-width: min(92vw, 1900px);
        max-height: 82dvh;

        object-fit: contain;
        object-position: center center;

        margin: auto;

        transform:
          translate3d(0,0,0)
          scale(1);

        transform-origin:
          center center;

        transition:
          transform 180ms
          cubic-bezier(.22,.61,.36,1),
          opacity 140ms ease;

        will-change: transform;

        -webkit-user-drag: none;
        user-drag: none;

        user-select: none;
        -webkit-user-select: none;

        touch-action: none;
      }


      #${VIEWER_ID}.is-gesturing
      .ds-pdp-viewer-image {
        transition:
          opacity 140ms ease;
      }


      /*
       * TOP
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-top {
        position: absolute;

        top: max(
          18px,
          env(safe-area-inset-top)
        );

        left: 50%;

        transform:
          translateX(-50%);

        z-index: 20;

        pointer-events: none;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-counter {
        min-width: 58px;

        height: 34px;

        padding:
          0 12px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 999px;

        background:
          rgba(255,255,255,.94);

        border:
          1px solid
          rgba(0,0,0,.09);

        box-shadow:
          0 4px 18px
          rgba(0,0,0,.06);

        color: #111;

        font-size: 13px;
        font-weight: 600;
      }


      /*
       * X
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-close {
        appearance: none;
        -webkit-appearance: none;

        position: absolute;

        top: max(
          16px,
          env(safe-area-inset-top)
        );

        right: max(
          16px,
          env(safe-area-inset-right)
        );

        z-index: 40;

        width: 42px;
        height: 42px;

        padding: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        border:
          1px solid
          rgba(0,0,0,.10);

        border-radius: 999px;

        background:
          rgba(255,255,255,.96);

        color: #111;

        box-shadow:
          0 5px 20px
          rgba(0,0,0,.07);

        cursor: pointer;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-close svg {
        width: 20px;
        height: 20px;

        fill: none;
        stroke: currentColor;

        stroke-width: 1.8;
        stroke-linecap: round;
      }


      /*
       * SETAS
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-nav {
        appearance: none;
        -webkit-appearance: none;

        position: absolute;

        top: 50%;

        transform:
          translateY(-50%);

        z-index: 30;

        width: 48px;
        height: 48px;

        padding: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        border:
          1px solid
          rgba(0,0,0,.10);

        border-radius: 999px;

        background:
          rgba(255,255,255,.94);

        color: #111;

        box-shadow:
          0 4px 20px
          rgba(0,0,0,.06);

        cursor: pointer;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-prev {
        left: 24px;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-next {
        right: 24px;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-nav svg {
        width: 23px;
        height: 23px;

        fill: none;
        stroke: currentColor;

        stroke-width: 1.8;

        stroke-linecap: round;
        stroke-linejoin: round;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-nav:disabled {
        opacity: .18;
        pointer-events: none;
      }


      /*
       * CONTROLES INFERIORES
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-bottom {
        position: absolute;

        left: 50%;

        bottom: max(
          18px,
          env(safe-area-inset-bottom)
        );

        transform:
          translateX(-50%);

        z-index: 35;

        display: flex;
        flex-direction: column;
        align-items: center;

        gap: 10px;

        pointer-events: none;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-controls {
        height: 44px;

        display: flex;
        align-items: center;

        padding: 0 5px;

        background:
          rgba(255,255,255,.96);

        border:
          1px solid
          rgba(0,0,0,.10);

        border-radius: 999px;

        box-shadow:
          0 5px 22px
          rgba(0,0,0,.07);

        pointer-events: auto;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-zoom-btn {
        appearance: none;
        -webkit-appearance: none;

        width: 36px;
        height: 36px;

        padding: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        border: 0;
        background: transparent;

        color: #111;

        font-size: 23px;
        line-height: 1;

        cursor: pointer;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-zoom-btn:disabled {
        opacity: .25;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-zoom-label {
        width: 56px;

        text-align: center;

        color: #111;

        font-size: 12px;
        font-weight: 600;
      }


      /*
       * DICA
       */

      #${VIEWER_ID}
      .ds-pdp-viewer-hint {
        padding:
          7px 11px;

        border-radius: 999px;

        background:
          rgba(17,17,17,.88);

        color: #fff;

        font-size: 11px;
        font-weight: 500;

        white-space: nowrap;

        opacity: 0;

        transform:
          translateY(5px);

        transition:
          opacity 180ms ease,
          transform 180ms ease;

        pointer-events: none;
      }


      #${VIEWER_ID}
      .ds-pdp-viewer-hint.is-visible {
        opacity: 1;

        transform:
          translateY(0);
      }


      /*
       * MOBILE
       */

      @media screen and (max-width: 989px) {

        #${VIEWER_ID}
        .ds-pdp-viewer-image {
          max-width: 96vw;
          max-height: 76dvh;
        }


        #${VIEWER_ID}
        .ds-pdp-viewer-nav {
          display: none;
        }


        #${VIEWER_ID}
        .ds-pdp-viewer-close {
          top: max(
            12px,
            env(safe-area-inset-top)
          );

          right: 12px;

          width: 40px;
          height: 40px;
        }


        #${VIEWER_ID}
        .ds-pdp-viewer-top {
          top: max(
            14px,
            env(safe-area-inset-top)
          );
        }


        #${VIEWER_ID}
        .ds-pdp-viewer-bottom {
          bottom: max(
            16px,
            env(safe-area-inset-bottom)
          );
        }

      }
      /*
       * ========================================================
       * HOLD ZOOM NA PDP MOBILE
       * ========================================================
       */

      @media screen and (max-width: 989px) {

        [class*="ai-sneaker-pdp-mobile-gallery-"] img {
          -webkit-touch-callout: none !important;
          -webkit-user-select: none !important;
          user-select: none !important;
          -webkit-user-drag: none !important;
        }


        html.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-image-"],

        html.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-gallery-"],

        html.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-mobile-gallery-"],

        html.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-mobile-track-"],

        html.ds-pdp-hold-zooming
        [data-mobile-slide],

        body.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-image-"],

        body.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-gallery-"],

        body.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-mobile-gallery-"],

        body.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-mobile-track-"],

        body.ds-pdp-hold-zooming
        [data-mobile-slide] {
          overflow: visible !important;
        }


        html.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-mobile-track-"],

        body.ds-pdp-hold-zooming
        [class*="ai-sneaker-pdp-mobile-track-"] {
          scroll-snap-type: none !important;
        }


        .ds-pdp-hold-zoom-target {
          position: relative !important;

          z-index: 999999 !important;

          transform-origin:
            var(--ds-hold-origin-x, 50%)
            var(--ds-hold-origin-y, 50%) !important;

          will-change: transform !important;

          transition:
            transform 160ms
            cubic-bezier(.22,.61,.36,1) !important;
        }


        .ds-pdp-hold-zoom-target.is-active {
          transform:
            translate3d(
              var(--ds-hold-pan-x, 0px),
              var(--ds-hold-pan-y, 0px),
              0
            )
            scale(
              var(--ds-hold-scale, 1.95)
            ) !important;

          transition:
            transform 60ms linear !important;
        }

      }
    `;

    document.head.appendChild(style);
  }

  /*
   * ============================================================
   * CRIA MODAL
   * ============================================================
   */

  function createViewer() {
    var old =
      document.getElementById(
        VIEWER_ID
      );

    if (old) {
      old.remove();
    }

    viewer =
      document.createElement(
        "div"
      );

    viewer.id = VIEWER_ID;

    viewer.setAttribute(
      "role",
      "dialog"
    );

    viewer.setAttribute(
      "aria-modal",
      "true"
    );

    viewer.setAttribute(
      "aria-label",
      "Fotos do produto"
    );

    viewer.setAttribute(
      "aria-hidden",
      "true"
    );

    viewer.innerHTML = `

      <div
        class="ds-pdp-viewer-stage"
        data-viewer-stage
      >

        <img
          class="ds-pdp-viewer-image"
          data-viewer-image
          draggable="false"
          alt=""
        >

      </div>


      <div
        class="ds-pdp-viewer-top"
      >

        <div
          class="ds-pdp-viewer-counter"
          data-viewer-counter
        >
          1 / 1
        </div>

      </div>


      <button
        type="button"
        class="ds-pdp-viewer-close"
        data-viewer-close
        aria-label="Fechar"
      >

        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M5 5L19 19"></path>
          <path d="M19 5L5 19"></path>
        </svg>

      </button>


      <button
        type="button"
        class="
          ds-pdp-viewer-nav
          ds-pdp-viewer-prev
        "
        data-viewer-prev
        aria-label="Imagem anterior"
      >

        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M15 5L8 12L15 19"></path>
        </svg>

      </button>


      <button
        type="button"
        class="
          ds-pdp-viewer-nav
          ds-pdp-viewer-next
        "
        data-viewer-next
        aria-label="Próxima imagem"
      >

        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M9 5L16 12L9 19"></path>
        </svg>

      </button>


      <div
        class="ds-pdp-viewer-bottom"
      >

        <div
          class="ds-pdp-viewer-hint"
          data-viewer-hint
        ></div>


        <div
          class="ds-pdp-viewer-controls"
        >

          <button
            type="button"
            class="ds-pdp-viewer-zoom-btn"
            data-viewer-minus
            aria-label="Diminuir zoom"
          >
            −
          </button>


          <span
            class="ds-pdp-viewer-zoom-label"
            data-viewer-zoom
          >
            100%
          </span>


          <button
            type="button"
            class="ds-pdp-viewer-zoom-btn"
            data-viewer-plus
            aria-label="Aumentar zoom"
          >
            +
          </button>

        </div>

      </div>

    `;

    document.body.appendChild(
      viewer
    );

    stage =
      viewer.querySelector(
        "[data-viewer-stage]"
      );

    viewerImage =
      viewer.querySelector(
        "[data-viewer-image]"
      );

    closeButton =
      viewer.querySelector(
        "[data-viewer-close]"
      );

    prevButton =
      viewer.querySelector(
        "[data-viewer-prev]"
      );

    nextButton =
      viewer.querySelector(
        "[data-viewer-next]"
      );

    minusButton =
      viewer.querySelector(
        "[data-viewer-minus]"
      );

    plusButton =
      viewer.querySelector(
        "[data-viewer-plus]"
      );

    zoomLabel =
      viewer.querySelector(
        "[data-viewer-zoom]"
      );

    counter =
      viewer.querySelector(
        "[data-viewer-counter]"
      );

    hint =
      viewer.querySelector(
        "[data-viewer-hint]"
      );

    bindViewerEvents();
  }

  /*
   * ============================================================
   * TRAVA SCROLL DA PÁGINA
   * ============================================================
   */

  function lockPage() {
    if (bodyBackup) return;

    pageScrollY =
      window.scrollY ||
      window.pageYOffset ||
      0;

    bodyBackup = {
      position:
        document.body.style.position,

      top:
        document.body.style.top,

      left:
        document.body.style.left,

      right:
        document.body.style.right,

      width:
        document.body.style.width,

      overflow:
        document.body.style.overflow
    };

    document.body.style.position =
      "fixed";

    document.body.style.top =
      "-" + pageScrollY + "px";

    document.body.style.left =
      "0";

    document.body.style.right =
      "0";

    document.body.style.width =
      "100%";

    document.body.style.overflow =
      "hidden";
  }

  function unlockPage() {
    if (!bodyBackup) return;

    document.body.style.position =
      bodyBackup.position;

    document.body.style.top =
      bodyBackup.top;

    document.body.style.left =
      bodyBackup.left;

    document.body.style.right =
      bodyBackup.right;

    document.body.style.width =
      bodyBackup.width;

    document.body.style.overflow =
      bodyBackup.overflow;

    bodyBackup = null;

    window.scrollTo(
      0,
      pageScrollY
    );
  }

  /*
   * ============================================================
   * ZOOM / PAN
   * ============================================================
   */

  function getPanBounds(
    targetScale
  ) {
    if (
      !stage ||
      !viewerImage
    ) {
      return {
        x: 0,
        y: 0
      };
    }

    var imageWidth =
      viewerImage.clientWidth;

    var imageHeight =
      viewerImage.clientHeight;

    var stageWidth =
      stage.clientWidth;

    var stageHeight =
      stage.clientHeight;

    return {
      x: Math.max(
        0,
        (
          imageWidth *
          targetScale -
          stageWidth
        ) / 2
      ),

      y: Math.max(
        0,
        (
          imageHeight *
          targetScale -
          stageHeight
        ) / 2
      )
    };
  }

  function clampPan() {
    if (scale <= 1.001) {
      panX = 0;
      panY = 0;
      return;
    }

    var bounds =
      getPanBounds(scale);

    panX =
      clamp(
        panX,
        -bounds.x,
        bounds.x
      );

    panY =
      clamp(
        panY,
        -bounds.y,
        bounds.y
      );
  }

  function renderTransform(
    immediate
  ) {
    if (!viewerImage) return;

    clampPan();

    if (immediate && viewer) {
      viewer.classList.add(
        "is-gesturing"
      );
    }

    viewerImage.style.transform =
      "translate3d(" +
      panX +
      "px," +
      panY +
      "px,0) scale(" +
      scale +
      ")";

    if (viewer) {
      viewer.classList.toggle(
        "is-zoomed",
        scale > 1.01
      );
    }

    if (zoomLabel) {
      zoomLabel.textContent =
        Math.round(
          scale * 100
        ) + "%";
    }

    if (minusButton) {
      minusButton.disabled =
        scale <=
        MIN_SCALE + 0.01;
    }

    if (plusButton) {
      plusButton.disabled =
        scale >=
        MAX_SCALE - 0.01;
    }
  }

  function finishGesture() {
    if (!viewer) return;

    requestAnimationFrame(
      function () {
        if (viewer) {
          viewer.classList.remove(
            "is-gesturing",
            "is-dragging"
          );
        }
      }
    );
  }

  function resetZoom(
    immediate
  ) {
    scale = 1;
    panX = 0;
    panY = 0;

    renderTransform(
      !!immediate
    );

    if (immediate) {
      finishGesture();
    }
  }

  /*
   * Zoom centralizado no ponto
   * onde a pessoa clicou/tocou.
   */

  function zoomAt(
    clientX,
    clientY,
    nextScale
  ) {
    if (
      !stage ||
      !viewerImage
    ) {
      return;
    }

    nextScale =
      clamp(
        nextScale,
        MIN_SCALE,
        MAX_SCALE
      );

    if (
      nextScale <=
      1.001
    ) {
      resetZoom(false);
      return;
    }

    var rect =
      stage.getBoundingClientRect();

    var centerX =
      rect.left +
      rect.width / 2;

    var centerY =
      rect.top +
      rect.height / 2;

    var offsetX =
      clientX -
      centerX;

    var offsetY =
      clientY -
      centerY;

    var ratio =
      nextScale /
      scale;

    panX =
      offsetX -
      (
        offsetX -
        panX
      ) *
      ratio;

    panY =
      offsetY -
      (
        offsetY -
        panY
      ) *
      ratio;

    scale =
      nextScale;

    renderTransform(false);
  }

  function stageCenter() {
    var rect =
      stage.getBoundingClientRect();

    return {
      x:
        rect.left +
        rect.width / 2,

      y:
        rect.top +
        rect.height / 2
    };
  }

  /*
   * ============================================================
   * TROCA DE IMAGEM
   * ============================================================
   */

  function updateNavigation() {
    if (!counter) return;

    counter.textContent =
      (
        currentIndex + 1
      ) +
      " / " +
      items.length;

    if (prevButton) {
      prevButton.disabled =
        currentIndex <= 0;
    }

    if (nextButton) {
      nextButton.disabled =
        currentIndex >=
        items.length - 1;
    }
  }

  function preloadAround(index) {
    [
      index - 1,
      index + 1
    ].forEach(function (i) {
      if (!items[i]) return;

      var preload =
        new Image();

      preload.src =
        items[i].src;
    });
  }

  function showImage(index) {
    if (
      !viewerImage ||
      !items.length
    ) {
      return;
    }

    index =
      clamp(
        index,
        0,
        items.length - 1
      );

    currentIndex =
      index;

    resetZoom(true);

    pointers.clear();

    var item =
      items[currentIndex];

    viewerImage.style.opacity =
      "0";

    viewerImage.alt =
      item.alt ||
      "Imagem do produto";

    function done() {
      viewerImage.style.opacity =
        "1";

      resetZoom(true);
    }

    viewerImage.onload =
      done;

    viewerImage.onerror =
      done;

    viewerImage.src =
      item.src;

    if (viewerImage.complete) {
      requestAnimationFrame(
        done
      );
    }

    updateNavigation();

    preloadAround(
      currentIndex
    );
  }

  function previousImage() {
    if (currentIndex <= 0) {
      return;
    }

    showImage(
      currentIndex - 1
    );
  }

  function nextImage() {
    if (
      currentIndex >=
      items.length - 1
    ) {
      return;
    }

    showImage(
      currentIndex + 1
    );
  }

  /*
   * ============================================================
   * ABRIR / FECHAR
   * ============================================================
   */

  var hintTimer = 0;

  function showHint() {
    if (!hint) return;

    clearTimeout(
      hintTimer
    );

    hint.textContent =
      isMobile()
        ? "Use dois dedos para ampliar"
        : "Role ou clique 2x para ampliar";

    hint.classList.add(
      "is-visible"
    );

    hintTimer =
      setTimeout(
        function () {
          if (hint) {
            hint.classList.remove(
              "is-visible"
            );
          }
        },
        2200
      );
  }

  function openViewer(
    clickedImage
  ) {
    var root =
      getPdpRoot(
        clickedImage
      );

    if (!root) return;

    items =
      collectImages(root);

    if (!items.length) {
      return;
    }

    currentIndex =
      findInitialIndex(
        root,
        clickedImage
      );

    originalImage =
      clickedImage;

    if (
      !viewer ||
      !viewer.isConnected
    ) {
      createViewer();
    }

    opened = true;

    lockPage();

    viewer.setAttribute(
      "aria-hidden",
      "false"
    );

    showImage(
      currentIndex
    );

    requestAnimationFrame(
      function () {
        viewer.classList.add(
          "is-open"
        );

        showHint();
      }
    );
  }

  function closeViewer() {
    if (
      !viewer ||
      !opened
    ) {
      return;
    }

    opened = false;

    clearTimeout(
      hintTimer
    );

    pointers.clear();

    viewer.classList.remove(
      "is-open",
      "is-zoomed",
      "is-dragging",
      "is-gesturing"
    );

    viewer.setAttribute(
      "aria-hidden",
      "true"
    );

    setTimeout(
      function () {
        resetZoom(true);

        unlockPage();

        originalImage =
          null;
      },
      190
    );
  }
  /*
   * ============================================================
   * HOLD ZOOM NA PDP
   * ============================================================
   */

  function getHoldImage(target) {
    if (
      !isMobile() ||
      !target
    ) {
      return null;
    }

    var image =
      target.tagName &&
      target.tagName.toLowerCase() === "img"
        ? target
        : target.closest
          ? target.closest("img")
          : null;

    if (!image) {
      return null;
    }

    /*
     * HOLD somente na galeria mobile.
     */
    if (
      !image.closest(
        '[class*="ai-sneaker-pdp-mobile-gallery-"]'
      )
    ) {
      return null;
    }

    if (
      !image.closest(
        "[data-mobile-slide]"
      )
    ) {
      return null;
    }

    return image;
  }


  function cancelHoldTimer() {
    clearTimeout(
      holdTimer
    );

    holdTimer = 0;
  }


  function setHoldOrigin(
    clientX,
    clientY
  ) {
    if (!holdTarget) {
      return;
    }

    var rect =
      holdTarget.getBoundingClientRect();

    if (
      !rect.width ||
      !rect.height
    ) {
      return;
    }

    var x =
      clamp(
        (
          (
            clientX -
            rect.left
          ) /
          rect.width
        ) * 100,
        0,
        100
      );

    var y =
      clamp(
        (
          (
            clientY -
            rect.top
          ) /
          rect.height
        ) * 100,
        0,
        100
      );

    holdTarget.style.setProperty(
      "--ds-hold-origin-x",
      x + "%"
    );

    holdTarget.style.setProperty(
      "--ds-hold-origin-y",
      y + "%"
    );
  }


  function activateHoldZoom(
    image,
    clientX,
    clientY
  ) {
    if (
      !image ||
      !holdTouching ||
      holdMoved
    ) {
      return;
    }

    cancelHoldTimer();

    holdImage =
      image;

    /*
     * Mesmo conceito do zoom antigo:
     * amplia o wrapper direto da imagem.
     */
    holdTarget =
      image.parentElement ||
      image;

    if (!holdTarget) {
      return;
    }

 holdActive =
  true;


/*
 * Só AGORA precisamos bloquear
 * o movimento normal da página/galeria.
 */
attachHoldMoveBlocker();

    holdPanX = 0;
    holdPanY = 0;

    var rect =
      holdTarget.getBoundingClientRect();

    holdMaxPanX =
      Math.max(
        0,
        rect.width *
        (
          HOLD_SCALE - 1
        ) /
        2
      );

    holdMaxPanY =
      Math.max(
        0,
        rect.height *
        (
          HOLD_SCALE - 1
        ) /
        2
      );

    holdTarget.classList.add(
      "ds-pdp-hold-zoom-target"
    );

    holdTarget.style.setProperty(
      "--ds-hold-scale",
      String(
        HOLD_SCALE
      )
    );

    holdTarget.style.setProperty(
      "--ds-hold-pan-x",
      "0px"
    );

    holdTarget.style.setProperty(
      "--ds-hold-pan-y",
      "0px"
    );

    setHoldOrigin(
      clientX,
      clientY
    );

    document.documentElement
      .classList.add(
        "ds-pdp-hold-zooming"
      );

    document.body
      .classList.add(
        "ds-pdp-hold-zooming"
      );

    /*
     * Garante que ao soltar o HOLD
     * não abra o fullscreen.
     */
    suppressGalleryClickUntil =
      Date.now() + 900;

    void holdTarget.offsetWidth;

    holdTarget.classList.add(
      "is-active"
    );
  }


  function releaseHoldZoom() {
    detachHoldMoveBlocker();
    cancelHoldTimer();

    document.documentElement
      .classList.remove(
        "ds-pdp-hold-zooming"
      );

    document.body
      .classList.remove(
        "ds-pdp-hold-zooming"
      );

    var releasedTarget =
      holdTarget;

    if (releasedTarget) {
      releasedTarget.classList.remove(
        "is-active"
      );

      window.setTimeout(
        function () {
          releasedTarget.classList.remove(
            "ds-pdp-hold-zoom-target"
          );

          releasedTarget.style.removeProperty(
            "--ds-hold-scale"
          );

          releasedTarget.style.removeProperty(
            "--ds-hold-origin-x"
          );

          releasedTarget.style.removeProperty(
            "--ds-hold-origin-y"
          );

          releasedTarget.style.removeProperty(
            "--ds-hold-pan-x"
          );

          releasedTarget.style.removeProperty(
            "--ds-hold-pan-y"
          );
        },
        180
      );
    }

    holdImage = null;
    holdTarget = null;

    holdTouching = false;
    holdActive = false;
    holdMoved = false;

    holdPanX = 0;
    holdPanY = 0;

    holdMaxPanX = 0;
    holdMaxPanY = 0;

    suppressGalleryClickUntil =
      Date.now() + 550;
  }


  function holdTouchStart(
    event
  ) {
    if (
      opened ||
      !isMobile() ||
      !event.touches ||
      event.touches.length !== 1
    ) {
      return;
    }

    var image =
      getHoldImage(
        event.target
      );

    if (!image) {
      return;
    }

    var touch =
      event.touches[0];

    cancelHoldTimer();

    holdTouching = true;
    holdActive = false;
    holdMoved = false;

    holdImage =
      image;

    holdStartX =
      touch.clientX;

    holdStartY =
      touch.clientY;

    holdTimer =
      window.setTimeout(
        function () {
          if (
            holdTouching &&
            !holdMoved &&
            holdImage
          ) {
            activateHoldZoom(
              holdImage,
              holdStartX,
              holdStartY
            );
          }
        },
        HOLD_DELAY
      );
  }


 function holdActiveTouchMove(
  event
) {
  /*
   * Esse listener só existe enquanto
   * o HOLD ZOOM está realmente ativo.
   *
   * Durante swipe normal ele nem sequer
   * fica registrado no navegador.
   */

  if (
    !holdActive ||
    !holdTarget ||
    !event.touches ||
    event.touches.length !== 1
  ) {
    return;
  }


  event.preventDefault();
  event.stopPropagation();

  if (
    event.stopImmediatePropagation
  ) {
    event.stopImmediatePropagation();
  }


  var touch =
    event.touches[0];


  var dx =
    touch.clientX -
    holdStartX;


  var dy =
    touch.clientY -
    holdStartY;


  holdPanX =
    clamp(
      dx,
      -holdMaxPanX,
      holdMaxPanX
    );


  holdPanY =
    clamp(
      dy,
      -holdMaxPanY,
      holdMaxPanY
    );


  holdTarget.style.setProperty(
    "--ds-hold-pan-x",
    holdPanX + "px"
  );


  holdTarget.style.setProperty(
    "--ds-hold-pan-y",
    holdPanY + "px"
  );
}


function attachHoldMoveBlocker() {
  document.addEventListener(
    "touchmove",
    holdActiveTouchMove,
    {
      capture: true,
      passive: false
    }
  );
}


function detachHoldMoveBlocker() {
  document.removeEventListener(
    "touchmove",
    holdActiveTouchMove,
    true
  );
}

  function holdTouchEnd() {
    cancelHoldTimer();

    if (holdActive) {
      releaseHoldZoom();
      return;
    }

    holdTouching = false;
    holdMoved = false;
    holdImage = null;
  }
  /*
   * ============================================================
   * PINCH HELPERS
   * ============================================================
   */

  function getTwoPointers() {
    var values =
      Array.from(
        pointers.values()
      );

    if (
      values.length < 2
    ) {
      return null;
    }

    return [
      values[0],
      values[1]
    ];
  }

  function pointerDistance(
    a,
    b
  ) {
    var dx =
      a.x - b.x;

    var dy =
      a.y - b.y;

    return Math.hypot(
      dx,
      dy
    );
  }

  /*
   * ============================================================
   * EVENTOS DO MODAL
   * ============================================================
   */

  function bindViewerEvents() {

    /*
     * FECHAR
     */

    closeButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        closeViewer();
      }
    );


    /*
     * ANTERIOR / PRÓXIMA
     */

    prevButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        previousImage();
      }
    );

    nextButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        nextImage();
      }
    );


    /*
     * BOTÃO -
     */

    minusButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        var center =
          stageCenter();

        zoomAt(
          center.x,
          center.y,
          scale - 0.45
        );
      }
    );


    /*
     * BOTÃO +
     */

    plusButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        var center =
          stageCenter();

        zoomAt(
          center.x,
          center.y,
          scale + 0.45
        );
      }
    );


    /*
     * ========================================================
     * POINTER DOWN
     * ========================================================
     */

    stage.addEventListener(
      "pointerdown",
      function (event) {
        if (!opened) return;

        /*
         * Evita comportamento padrão
         * somente dentro do viewer.
         */

        event.preventDefault();

        try {
          stage.setPointerCapture(
            event.pointerId
          );
        } catch (error) {}

        pointers.set(
          event.pointerId,
          {
            x: event.clientX,
            y: event.clientY
          }
        );

        /*
         * PINCH iniciou.
         */

              if (
          pointers.size === 2
        ) {
          var pair =
            getTwoPointers();

          if (!pair) return;

          pinchStartDistance =
            pointerDistance(
              pair[0],
              pair[1]
            );

          pinchStartScale =
            scale;

          /*
           * Ponto médio ENTRE OS DOIS DEDOS.
           */
          var midpointX =
            (
              pair[0].x +
              pair[1].x
            ) / 2;

          var midpointY =
            (
              pair[0].y +
              pair[1].y
            ) / 2;

          var stageRect =
            stage.getBoundingClientRect();

          var stageCenterX =
            stageRect.left +
            stageRect.width / 2;

          var stageCenterY =
            stageRect.top +
            stageRect.height / 2;

          /*
           * Descobre qual ponto real da imagem
           * está exatamente embaixo do meio
           * dos dois dedos.
           *
           * Esse ponto será mantido preso
           * entre os dedos durante o zoom.
           */
          pinchFocalX =
            (
              midpointX -
              stageCenterX -
              panX
            ) /
            scale;

          pinchFocalY =
            (
              midpointY -
              stageCenterY -
              panY
            ) /
            scale;

          viewer.classList.add(
            "is-gesturing"
          );

          return;
        }

        /*
         * 1 dedo.
         */

        dragStartX =
          event.clientX;

        dragStartY =
          event.clientY;

        dragStartPanX =
          panX;

        dragStartPanY =
          panY;

        if (scale > 1.01) {
          viewer.classList.add(
            "is-dragging",
            "is-gesturing"
          );
        }
      }
    );


    /*
     * ========================================================
     * POINTER MOVE
     * ========================================================
     */

    stage.addEventListener(
      "pointermove",
      function (event) {
        if (
          !opened ||
          !pointers.has(
            event.pointerId
          )
        ) {
          return;
        }

        event.preventDefault();

        pointers.set(
          event.pointerId,
          {
            x: event.clientX,
            y: event.clientY
          }
        );

        /*
         * PINCH
         */

            if (
          pointers.size >= 2
        ) {
          var pair =
            getTwoPointers();

          if (!pair) return;

          var distance =
            pointerDistance(
              pair[0],
              pair[1]
            );

          if (
            pinchStartDistance <= 0
          ) {
            return;
          }

          /*
           * Escala baseada na distância
           * atual dos dois dedos.
           */
          var nextScale =
            pinchStartScale *
            (
              distance /
              pinchStartDistance
            );

          nextScale =
            clamp(
              nextScale,
              MIN_SCALE,
              MAX_SCALE
            );


          /*
           * Novo ponto médio atual
           * entre os dois dedos.
           */
          var midpointX =
            (
              pair[0].x +
              pair[1].x
            ) / 2;

          var midpointY =
            (
              pair[0].y +
              pair[1].y
            ) / 2;


          var stageRect =
            stage.getBoundingClientRect();

          var stageCenterX =
            stageRect.left +
            stageRect.width / 2;

          var stageCenterY =
            stageRect.top +
            stageRect.height / 2;


          scale =
            nextScale;


          /*
           * ESTA É A PARTE QUE MUDA O COMPORTAMENTO.
           *
           * Em vez de ampliar pelo centro,
           * mantém o ponto escolhido da foto
           * exatamente embaixo dos dedos.
           */
          panX =
            (
              midpointX -
              stageCenterX
            ) -
            (
              pinchFocalX *
              scale
            );

          panY =
            (
              midpointY -
              stageCenterY
            ) -
            (
              pinchFocalY *
              scale
            );


          renderTransform(
            true
          );

          return;
        }

        /*
         * PAN
         */

        if (scale > 1.01) {
          var dx =
            event.clientX -
            dragStartX;

          var dy =
            event.clientY -
            dragStartY;

          panX =
            dragStartPanX +
            dx;

          panY =
            dragStartPanY +
            dy;

          renderTransform(true);
        }
      }
    );


    /*
     * ========================================================
     * POINTER UP
     * ========================================================
     */

    function finishPointer(event) {
      if (!opened) return;

      var pointer =
        pointers.get(
          event.pointerId
        );

      pointers.delete(
        event.pointerId
      );

      /*
       * Se ainda existe outro dedo,
       * não finaliza gesto.
       */

      if (
        pointers.size > 0
      ) {
        if (
          pointers.size === 1
        ) {
          var remaining =
            Array.from(
              pointers.values()
            )[0];

          dragStartX =
            remaining.x;

          dragStartY =
            remaining.y;

          dragStartPanX =
            panX;

          dragStartPanY =
            panY;
        }

        return;
      }

      viewer.classList.remove(
        "is-dragging"
      );

      /*
       * ======================================================
       * SWIPE
       * ======================================================
       *
       * Só troca foto se estiver 100%.
       */

      if (
        scale <= 1.01 &&
        pointer
      ) {
        var dx =
          event.clientX -
          dragStartX;

        var dy =
          event.clientY -
          dragStartY;

        if (
          Math.abs(dx) >
          SWIPE_THRESHOLD &&
          Math.abs(dx) >
          Math.abs(dy)
        ) {
          if (dx < 0) {
            nextImage();
          } else {
            previousImage();
          }

          finishGesture();

          return;
        }
      }

      /*
       * ======================================================
       * DUPLO TOQUE
       * ======================================================
       */

      if (
        event.pointerType ===
        "touch"
      ) {
        var now =
          Date.now();

        var distanceFromLast =
          Math.hypot(
            event.clientX -
              lastTapX,

            event.clientY -
              lastTapY
          );

        if (
          now -
            lastTapTime <=
            DOUBLE_TAP_TIME &&
          distanceFromLast <=
            DOUBLE_TAP_DISTANCE
        ) {
          if (scale > 1.01) {
            resetZoom(false);
          } else {
            zoomAt(
              event.clientX,
              event.clientY,
              DOUBLE_SCALE
            );
          }

          lastTapTime = 0;
        } else {
          lastTapTime =
            now;

          lastTapX =
            event.clientX;

          lastTapY =
            event.clientY;
        }
      }

      finishGesture();
    }

    stage.addEventListener(
      "pointerup",
      finishPointer
    );

    stage.addEventListener(
      "pointercancel",
      function (event) {
        pointers.delete(
          event.pointerId
        );

        if (!pointers.size) {
          finishGesture();
        }
      }
    );


    /*
     * ========================================================
     * DUPLO CLIQUE DESKTOP
     * ========================================================
     */

    stage.addEventListener(
      "dblclick",
      function (event) {
        if (
          event.pointerType ===
          "touch"
        ) {
          return;
        }

        event.preventDefault();

        if (scale > 1.01) {
          resetZoom(false);
        } else {
          zoomAt(
            event.clientX,
            event.clientY,
            DOUBLE_SCALE
          );
        }
      }
    );


    /*
     * ========================================================
     * RODINHA DO MOUSE
     * ========================================================
     */

    stage.addEventListener(
      "wheel",
      function (event) {
        if (
          !opened ||
          isMobile()
        ) {
          return;
        }

        event.preventDefault();

        var factor =
          event.deltaY < 0
            ? 0.28
            : -0.28;

        zoomAt(
          event.clientX,
          event.clientY,
          scale + factor
        );
      },
      {
        passive: false
      }
    );


    /*
     * Evita arraste nativo.
     */

    viewerImage.addEventListener(
      "dragstart",
      function (event) {
        event.preventDefault();
      }
    );
  }

  /*
   * ============================================================
   * CLIQUE NA PDP
   * ============================================================
   *
   * Precisamos diferenciar:
   *
   * TAP = abre
   * SWIPE = não abre
   */

 function cancelGalleryHoldForMovement() {
  if (holdTouching && !holdActive) {
    holdMoved = true;
    cancelHoldTimer();
  }
}

 function markGalleryMovement() {
  galleryMoved = true;
  suppressGalleryClickUntil = Math.max(
    suppressGalleryClickUntil,
    Date.now() + 800
  );
  cancelGalleryHoldForMovement();
}

 function galleryPointerDown(event) {
  if (opened) return;

  var image = getProductImage(event.target);
  if (!image) return;

  if (isMobile() && event.pointerType === "touch") {
    galleryTouchPointers.add(event.pointerId);

    if (galleryTouchPointers.size > 1) {
      galleryMultiTouch = true;
      galleryPointer = null;
      markGalleryMovement();
      cancelHoldTimer();
      if (holdActive) releaseHoldZoom();
      return;
    }
  }

  if (galleryMultiTouch) return;

  galleryPointer = event.pointerId;
  galleryLastPointerType = event.pointerType || "";
  galleryStartX = event.clientX;
  galleryStartY = event.clientY;
  galleryStartAt = Date.now();
  galleryStartPageX = window.scrollX || window.pageXOffset || 0;
  galleryStartPageY = window.scrollY || window.pageYOffset || 0;
  galleryTouchTrack = image.closest('[data-mobile-track]');
  galleryStartTrackX = galleryTouchTrack ? galleryTouchTrack.scrollLeft : 0;
  galleryMoved = false;
 }

 function galleryPointerMove(event) {
  if (galleryPointer !== event.pointerId) return;

  var distance = Math.hypot(
    event.clientX - galleryStartX,
    event.clientY - galleryStartY
  );

  if (distance > HOLD_MOVE_CANCEL) {
    cancelGalleryHoldForMovement();
  }

  if (distance > GALLERY_MOVE_CANCEL) {
    markGalleryMovement();
  }
 }

 // No Android/iOS, a rolagem nativa pode cancelar o pointer ANTES
 // de entregar o movimento final; touchmove captura o gesto a tempo.
 function galleryTouchMove(event) {
  if (!isMobile() || (galleryPointer === null && !holdTouching)) return;

  if (event.touches && event.touches.length > 1) {
    galleryMultiTouch = true;
    markGalleryMovement();
    cancelHoldTimer();
    return;
  }

  if (!event.touches || !event.touches.length) return;
  var touch = event.touches[0];

  // O fluxo com dois dedos já foi invalidado acima.
  if (galleryPointer !== null) {
    var distance = Math.hypot(
      touch.clientX - galleryStartX,
      touch.clientY - galleryStartY
    );
    if (distance > HOLD_MOVE_CANCEL) cancelGalleryHoldForMovement();
    if (distance > GALLERY_MOVE_CANCEL) markGalleryMovement();
  } else if (holdTouching && !holdActive) {
    var holdDistance = Math.hypot(
      touch.clientX - holdStartX,
      touch.clientY - holdStartY
    );
    if (holdDistance > HOLD_MOVE_CANCEL) cancelGalleryHoldForMovement();
  }
 }

 function galleryScrolled() {
  // Rolagem da página ou do próprio carrossel invalida o toque.
  if (galleryPointer !== null) markGalleryMovement();
  // Às vezes o scroll começa antes do primeiro pointermove.
  if (holdTouching && !holdActive) cancelGalleryHoldForMovement();
 }

 function galleryPointerCancel(event) {
  // IMPORTANTE: pointercancel significa que o navegador assumiu o
  // gesto (scroll / swipe / pinch), NUNCA um toque intencional.
  if (event.pointerType === "touch") {
    galleryTouchPointers.delete(event.pointerId);
  }
  if (galleryPointer === event.pointerId || galleryMultiTouch) {
    galleryPointer = null;
    markGalleryMovement();
  }
  if (!galleryTouchPointers.size) galleryMultiTouch = false;
  galleryTouchTrack = null;
  cancelGalleryHoldForMovement();
  cancelHoldTimer();
 }

 function galleryPointerEnd(event) {
  if (event.type === "pointercancel") {
    galleryPointerCancel(event);
    return;
  }

  var wasMultiTouch = galleryMultiTouch;
  if (event.pointerType === "touch") {
    galleryTouchPointers.delete(event.pointerId);
  }
  if (wasMultiTouch) {
    galleryPointer = null;
    markGalleryMovement();
    if (!galleryTouchPointers.size) galleryMultiTouch = false;
    galleryTouchTrack = null;
    return;
  }
  if (galleryPointer !== event.pointerId) return;

  var finalDistance = Math.hypot(
    event.clientX - galleryStartX,
    event.clientY - galleryStartY
  );
  var pageDistance = Math.hypot(
    (window.scrollX || window.pageXOffset || 0) - galleryStartPageX,
    (window.scrollY || window.pageYOffset || 0) - galleryStartPageY
  );
  var trackDistance = galleryTouchTrack
    ? Math.abs(galleryTouchTrack.scrollLeft - galleryStartTrackX)
    : 0;
  var tookTooLong = Date.now() - galleryStartAt > GALLERY_TAP_MAX_MS;

  var wasMoved = galleryMoved ||
    finalDistance > GALLERY_MOVE_CANCEL ||
    pageDistance > 2 ||
    trackDistance > 2 ||
    tookTooLong;

  galleryPointer = null;
  galleryTouchTrack = null;
  galleryMoved = false;

  if (wasMoved) {
    markGalleryMovement();
    return;
  }

  var image = getProductImage(event.target);
  if (isMobile() && (event.pointerType === "touch" || event.pointerType === "pen") && image &&
      !opened && !holdActive &&
      Date.now() >= suppressGalleryClickUntil) {
    suppressGalleryClickUntil = Date.now() + 700;
    openViewer(image);
  }
 }

 function galleryClick(event) {
  var image = getProductImage(event.target);
  if (!image || opened) return;

  if (Date.now() < suppressGalleryClickUntil) return;

  // MOBILE: pointerup validado já abre o zoom; click sintético NÃO
  // pode abri-lo depois de swipe, scroll ou pointercancel.
  // detail=0 preserva ativação por teclado / acessibilidade.
  if (isMobile() && event.detail !== 0 && galleryLastPointerType !== "mouse") return;

  event.preventDefault();
  event.stopPropagation();
  openViewer(image);
 }

  /*
   * ============================================================
   * TECLADO
   * ============================================================
   */

  function keyboardHandler(
    event
  ) {
    if (!opened) return;

    if (
      event.key ===
      "Escape"
    ) {
      event.preventDefault();

      closeViewer();

      return;
    }

    if (
      event.key ===
      "ArrowLeft"
    ) {
      event.preventDefault();

      if (scale <= 1.01) {
        previousImage();
      }

      return;
    }

    if (
      event.key ===
      "ArrowRight"
    ) {
      event.preventDefault();

      if (scale <= 1.01) {
        nextImage();
      }
    }
  }

  /*
   * ============================================================
   * RESIZE
   * ============================================================
   */

  function resizeHandler() {
    if (!opened) return;

    clampPan();

    renderTransform(true);

    finishGesture();
  }

  /*
   * ============================================================
   * INIT
   * ============================================================
   */

  function initialize() {
    cleanupOldZoom();

    injectStyles();

    if (
      !viewer ||
      !viewer.isConnected
    ) {
      createViewer();
    }

    /*
     * Impede menu/drag das imagens.
     */

    document
      .querySelectorAll(
        '[class*="ai-sneaker-pdp-mobile-gallery-"] img,' +
        '[class*="ai-sneaker-pdp-main-image-"] img'
      )
      .forEach(function (image) {
        image.setAttribute(
          "draggable",
          "false"
        );
      });
  }

  /*
   * ============================================================
   * LISTENERS GLOBAIS
   * ============================================================
   */
  /*
   * HOLD antigo.
   *
   * touchmove precisa ser passive:false
   * porque quando o zoom entra,
   * passamos a controlar o movimento.
   */

  document.addEventListener(
    "touchstart",
    holdTouchStart,
    {
      capture: true,
      passive: true
    }
  );



  document.addEventListener(
    "touchmove",
    galleryTouchMove,
    {
      capture: true,
      passive: true
    }
  );

  document.addEventListener(
    "scroll",
    galleryScrolled,
    {
      capture: true,
      passive: true
    }
  );

  document.addEventListener(
    "touchend",
    holdTouchEnd,
    {
      capture: true,
      passive: true
    }
  );

  document.addEventListener(
    "touchcancel",
    holdTouchEnd,
    {
      capture: true,
      passive: true
    }
  );
 document.addEventListener(
  "pointerdown",
  galleryPointerDown,
  {
    capture: true,
    passive: true
  }
);


document.addEventListener(
  "pointermove",
  galleryPointerMove,
  {
    capture: true,
    passive: true
  }
);


document.addEventListener(
  "pointerup",
  galleryPointerEnd,
  {
    capture: true,
    passive: true
  }
);


document.addEventListener(
  "pointercancel",
  galleryPointerCancel,
  {
    capture: true,
    passive: true
  }
);

  document.addEventListener(
    "click",
    galleryClick,
    true
  );

  document.addEventListener(
    "keydown",
    keyboardHandler
  );

  window.addEventListener(
    "resize",
    resizeHandler,
    {
      passive: true
    }
  );

  /*
   * Bloqueia context menu somente
   * nas imagens da PDP.
   */

  document.addEventListener(
    "contextmenu",
    function (event) {
      var image =
        getProductImage(
          event.target
        );

      if (
        image &&
        isMobile()
      ) {
        event.preventDefault();
      }
    },
    true
  );

  /*
   * Shopify Theme Editor.
   */

  document.addEventListener(
    "shopify:section:load",
    function () {
      initialize();
    }
  );

  /*
   * DOM READY
   */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }

  /*
   * ============================================================
   * DESTROY
   * ============================================================
   */

  window[GLOBAL_KEY] = {

    close: closeViewer,

    destroy: function () {
      try {
        closeViewer();
      } catch (error) {}

      var style =
        document.getElementById(
          STYLE_ID
        );

      if (style) {
        style.remove();
      }

      var modal =
        document.getElementById(
          VIEWER_ID
        );

      if (modal) {
        modal.remove();
      }

      viewer = null;
      stage = null;
      viewerImage = null;
    }
  };

})();